import React from 'react'
import { TableGroup } from '@therms/atalaya'
// import PropTypes from 'prop-types'

function TableHeadRow() {
  return (
    <TableGroup.HeadRow>
      <TableGroup.HeadCell canSort>Name</TableGroup.HeadCell>

      <TableGroup.HeadCell>Address</TableGroup.HeadCell>

      <TableGroup.HeadCell canSort>Timezone</TableGroup.HeadCell>
    </TableGroup.HeadRow>
  )
}

TableHeadRow.propTypes = {}

export { TableHeadRow }
